import React from "react";
import Modal from "react-modal";

import styled from "styled-components";
import { cosmeticIQApi } from "../service/api";
import { useData } from "../context/DataProvider";
import { useNavigate } from "react-router-dom";



const RedirectModal = ({ isOpen }) => {
    const { setIsAuthenticated,isAuthenticated} = useData();
    const navigate = useNavigate();
    const handleSignOut = () => {
        localStorage.clear();
            cosmeticIQApi.logout();
            setIsAuthenticated(!isAuthenticated);
            navigate('/login');
        };
    
    

    return (
        <Modal
            isOpen={isOpen}
            style={{
                overlay: {  
                    backdropFilter: "blur(5px)", 
                    zIndex:1000,
                    backgroundColor: "rgba(255, 255, 255, 0.4)" 
                }
                    ,
                content: {
                  
                    width: "100%",
                    alignItems:'center',
                    justifyContent:'center',
                    height: "100%",
                    margin: "auto",
                    display: "flex",
                    background:'transparent',
                    border: "none",
                    
                    
                }
            }}
        >
            
            

            
            <div style={{
                padding: "32px",
                
                display:'flex',
                
                border: "none",
                borderRadius: "32px",
                boxShadow:' 0px 0px 40px 0.66px rgba(0, 0, 0, 0.06)',
                
                background: "rgba(255, 255, 255, 1)",
            }}>
                
                    
                    <ProductInfo>
                            <P1Txt2>Session Expired!</P1Txt2>
                        
                        
                        
  <P1Txt>
    Your session has expired. Please log in to refresh your session.
  </P1Txt>
  <LoginButton onClick={handleSignOut}>
    <LoginButtonTxt>Login</LoginButtonTxt>
  </LoginButton>
    

                    </ProductInfo>
                

            </div>
        </Modal>
    );
};

export default RedirectModal;

const ProductInfo = styled.div`
width: 100%;
height: 100%;
display: flex;
overflow:scroll;
align-items: center;
flex-direction:column;

gap:24px;

`

const LoginButton = styled.button`
cursor:pointer;
border:none;
width: 100px;
align-items:center;
justify-content:center;
padding: 0px 20px;
flex-direction:row;display:flex;
align-items:center;
justifySelf: start;
gap: 8px;
border-radius: 1000px;
background: linear-gradient(90deg, #DCFFAD 0%, #F6FFDB 50%, #BDDEFF 100%);

`
const LoginButtonTxt= styled.p`
font-size: 14px;
font-weight: 700;
line-height: 16.8px;
letter-spacing: -0.01em;
text-align: center;
text-underline-position: from-font;
text-decoration-skip-ink: none;
color: #202327;


`
const P1Txt = styled.p`

font-weight: 500;
font-size: 14px;
line-height: 120%;
letter-spacing: 0%;
margin:0;
color:rgba(47, 50, 55, 0.6)

`
const P1Txt2 = styled.p`
margin:0;
font-weight: 600;
font-size: 32px;
line-height: 110.00000000000001%;
letter-spacing: -1%;
color:rgba(32, 35, 39, 1);
`
